export default {
  video_player_title: "Reproductor de Video",
};
